import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MuiCheckbox from '@material-ui/core/Checkbox';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTooltip from '@material-ui/core/Tooltip';

const styles = () => ({
  selectCell: {
    width: '48px',
    padding: '0 8px',
  },
});

/**
 * Component to render a checkbox cell for selection in tables
 * Can be used in both the header and rows of the table
 */
const TableSelectColumn = props => {
  const {
    classes,
    checked,
    indeterminate,
    onChange,
    disabled,
    tooltip,
    align,
  } = props;

  return (
    <MuiTableCell
      className={classes.selectCell}
      padding="checkbox"
      align={align || 'center'}>
      <MuiTooltip title={tooltip || ''} placement="top">
        <span>
          <MuiCheckbox
            checked={checked}
            indeterminate={indeterminate}
            onChange={onChange}
            disabled={disabled}
            color="primary"
            inputProps={{ 'aria-label': 'select all' }}
          />
        </span>
      </MuiTooltip>
    </MuiTableCell>
  );
};

TableSelectColumn.propTypes = {
  classes: PropTypes.object.isRequired,
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  align: PropTypes.string,
};

TableSelectColumn.defaultProps = {
  checked: false,
  indeterminate: false,
  disabled: false,
  tooltip: '',
};

export default withStyles(styles)(TableSelectColumn);
